module.exports = __webpack_public_path__ + "static/media/file.499e04ed.svg";